/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Paste_NowInputs */



/**
* | output |
* | --- |
* | "Rather not wait? Share your notes." |
*
* @param {Meeting_Report_Paste_NowInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_paste_now = /** @type {((inputs?: Meeting_Report_Paste_NowInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Paste_NowInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Niet wachten? Deel je notities.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas envie d'attendre ? Partagez vos notes.")
	return /** @type {LocalizedString} */ ("Rather not wait? Share your notes.")
});